<script>
import formBasicMixin from '@phoenix/mixins/formBasicMixin';
import FormGroup from '@maison/components/form/FormGroup';
import TextField from '@maison/components/form/fields/TextField';
import { defineAsyncComponent } from 'vue';
import { PhxsgIcon } from '@sg/src/View/Components/Atoms/Icon';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    FormGroup,
    TextField,
    PhxsgIcon,
    PhxsgButton,
  },

  mixins: [formBasicMixin],

  created() {
    this.setFields({
      email: {
        id: 'email',
        name: 'email',
        label: this.$t('Footer.newsletterForm.label'),
        placeholder: this.$t('Footer.newsletterForm.placeholder'),
        value: this.email,
        required: true,
        type: 'email',
      },
    });
  },

  methods: {
    submit() {
      const email = this.fields.email.value;

      if (email) {
        window.location.href = `${window.route('newsletter_page')}?email=${encodeURIComponent(email)}`;
      }
    },
  },
};
</script>

<template>
  <phoenix-form
    v-model="fields"
    data-cy="newsletter-form-footer"
    method="get"
    :should-reset-form-on-submit="true"
    :should-display-submit-button="false"
    @submit.prevent="submit"
  >
    <form-group :attrs="fields.email">
      <text-field v-model="fields.email.value" />

      <template #icon>
        <PhxsgButton bare class="input-adornment input-adornment--end">
          <template #content>
            <PhxsgIcon id="arrow-right" size="md" bidirectional />
          </template>
        </PhxsgButton>
      </template>
    </form-group>
  </phoenix-form>
</template>
